import { render, staticRenderFns } from "./GiftCardPaymentForBeginnersSuccess.vue?vue&type=template&id=bb2140ba&scoped=true&"
import script from "./GiftCardPaymentForBeginnersSuccess.vue?vue&type=script&lang=js&"
export * from "./GiftCardPaymentForBeginnersSuccess.vue?vue&type=script&lang=js&"
import style0 from "./GiftCardPaymentForBeginnersSuccess.vue?vue&type=style&index=0&id=bb2140ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2140ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
